import { useSelector } from "react-redux";
import { type DataType } from "./ImportDialog";
import { isWhatnotAllowedToDirectImportSelector } from "src/store/uploads/selector";

export function usePreventImportWhatnot(dataType: DataType) {
  return !useSelector((state: any) =>
    isWhatnotAllowedToDirectImportSelector(state, dataType)
  );
}

export default usePreventImportWhatnot;
